












import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import Paper from "@/components/Paper.vue";
import { Letter } from "@/models/definitions";

@Component({
  components: {
    Paper,
  },
})
export default class Letters extends Vue {
  @Prop({ required: true }) readonly readerName!: string;

  private letters: Letter[] = [];

  mounted() {
    const params: { [id: string]: string } = {};
    if (process.env.NODE_ENV == "development") {
      params.debug = "true";
    }

    axios
      .get(process.env.VUE_APP_API_ROOT_URL + "api/posts/" + this.readerName, {
        params,
      })
      .then((response) => (this.letters = response.data))
      .catch((reason) => console.error(reason.response?.data?.["Message"]));
  }
}
